<template>
  <div>
    <b-modal
      id="modal-active-card-patch"
      centered
      size="lg"
      :hide-footer="true"
      title="Управління картою"
      @hidden="resetModal"
    >
      <b-tabs v-model="currentActiveTab">
        <b-tab title="Інформація" v-on:click="currentActiveTab = 0">
          <div class="p-3 text-center">
            <p class="h5">
              <strong>{{ card.product.name }}</strong>
            </p>
            <div class="row text-center mt-3">
              <b-col lg="6" sm="auto" class="mt-2">
                <span class="fw-bold">Дата закінчення :</span>
                <b-form-datepicker
                  :disabled="disabledInputs"
                  size="sm"
                  v-model="card.expiration_date"
                >
                </b-form-datepicker>
              </b-col>
              <b-col lg="6" sm="auto" class="mt-2">
                <span class="fw-bold mt-2">Визитів :</span>
                <div class="d-flex justify-content-center">
                  <b-input-group>
                    <b-form-input
                      size="sm"
                      type="number"
                      :disabled="disabledInputs"
                      @blur="$v.card.visits.$touch()"
                      :class="{
                        'is-invalid':
                          $v.card.visits.$error && $v.card.visits.$dirty,
                      }"
                      v-model="card.visits"
                    >
                    </b-form-input>
                  </b-input-group>
                </div>
              </b-col>
            </div>
            <div class="row">
              <b-col>
                <b-button
                  class="mt-4"
                  v-if="disabledInputs"
                  variant="outline-success"
                  size="sm"
                  v-on:click="toggleInputs"
                >
                  Редагувати
                </b-button>
                <b-button
                  v-else
                  class="mt-4"
                  variant="success"
                  size="sm"
                  v-on:click="patchCard"
                >
                  Зберегти
                </b-button>
              </b-col>
            </div>
          </div>
        </b-tab>
        <b-tab title="Перенос" v-on:click="currentActiveTab = 1">
          <div class="row p-3 text-center">
            <p class="">
              Клієнт: <strong>{{ client.surname }} {{ client.name }} </strong>
            </p>
            <!--            <p> Новый клиент : </p>-->
            <b-form-input
              class="col-4 offset-4"
              placeholder="Выберите клиента"
              v-model="searchString"
            ></b-form-input>
            <div
              v-if="clientList.length"
              class="client-search mt-3 overflow-auto col-4 offset-4"
            >
              <b-list-group v-for="client in clientList" :key="client.id">
                <b-list-group-item
                  v-on:click="setClient(client)"
                  class="mt-1 client-in-list"
                >
                  {{ client.surname }} {{ client.name }}
                </b-list-group-item>
              </b-list-group>
            </div>
            <b-button
              variant="outline-success"
              class="col-4 offset-4 mt-4"
              v-if="chosenClient"
              v-on:click="reassignCard"
            >
              Перенести
            </b-button>
          </div>
        </b-tab>
        <b-tab title="Обмен">
          <div class="p-3 text-center">
            <p class="text-black h5 fw-bold">Поки не готово :(</p>
          </div>
        </b-tab>
        <b-tab v-if="card.debt" title="Борг" v-on:click="currentActiveTab = 3">
          <div class="row">
            <div class="text-center p-3 mt-2 w-50 col-7 offset-2">
              <p class="h4 text-black">Борг по карті : {{ card.debt }} грн</p>
              <b-form-select :options="paymentOptions" v-model="paymentType">
              </b-form-select>
              <b-button
                variant="outline-success"
                class="mt-2"
                v-on:click="payDebt"
              >
                Оплатити
              </b-button>
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </b-modal>
  </div>
</template>

<script>
import { maxValue, required, minValue } from "vuelidate/lib/validators";

const moment = require("moment");
export default {
  name: "ClientCardControls",
  props: {
    card: Object,
    activeTab: Number,
    client: Object,
  },
  data: function () {
    return {
      currentActiveTab: 0,
      disabledInputs: true,
      searchString: null,
      chosenClient: null,
      clientList: [],
      paymentOptions: [
        { value: 1, text: "Готівка" },
        { value: 2, text: "Картка" },
      ],
      paymentType: 1,
    };
  },
  validations() {
    return {
      card: {
        visits: {
          required,
          maxValue: maxValue(this.card.total_visits),
          minValue: minValue(0),
        },
      },
    };
  },
  watch: {
    currentActiveTab: function () {
      this.disabledInputs = true;
    },
    activeTab: function (newVal) {
      this.currentActiveTab = newVal;
    },
    searchString: function (newVal) {
      if (!newVal.length || newVal.length < 3) {
        this.clientList = [];
        return;
      }
      this.searchClients(newVal);
    },
  },
  mounted() {
    this.currentActiveTab = this.activeTab;
  },
  methods: {
    toggleInputs() {
      this.disabledInputs = !this.disabledInputs;
    },
    resetModal() {
      this.disabledInputs = true;
      this.chosenClient = null;
      this.searchString = null;
      this.currentActiveTab = 0;
    },
    setClient(client) {
      this.chosenClient = client;
      this.searchString = client.surname + " " + client.name;
      this.clientList = [];
    },
    async searchClients(query) {
      let response = await this.$api.clients.searchClients(query);
      this.clientList = response.data;
    },
    async patchCard() {
      this.$v.$touch();
      if (this.$v.$invalid) return;
      let payload = {
        card_id: this.card.id,
        visits: this.card.visits,
        expire_date: moment(this.card.expiration_date).format(
          "DD MM YYYY HH:mm",
        ),
      };
      await this.$api.activecards.patchCard(payload);
      this.toggleInputs();
      this.$emit("showModal", "Картка відредагована!", "green");
      this.$nextTick(() => {
        this.$bvModal.hide("modal-active-card-patch");
      });
    },
    async reassignCard() {
      let result = confirm(
        `Перенести карту ${this.card.product.name} на ${this.chosenClient.surname} ${this.chosenClient.name}?`,
      );
      if (!result) return;
      await this.$api.activecards.reassignCard(
        this.card.id,
        this.chosenClient.id,
      );
      this.$nextTick(() => {
        this.$bvModal.hide("modal-active-card-patch");
      });
    },
    async payDebt() {
      let payload = {
        card_id: this.card.id,
        amount: this.card.debt,
        payment_type: this.paymentType,
      };
      await this.$api.activecards.payDebt(payload);
      this.$emit("refresh");
      this.$nextTick(() => {
        this.$bvModal.hide("modal-active-card-patch");
      });
    },
  },
};
</script>

<style scoped>
.client-search {
  max-height: 30vh;
}
.client-in-list {
  transition: 0.25s all ease-out;
}
.client-in-list:hover {
  border-radius: 10px;
  color: white;
  background: #312d2d;
}
</style>
